<template>
    <!--<Button type="success" @click="upBtn()">上传</Button>-->
    <div class="upload_box">
        <input id="uploadForm" type="file" @change="changePic($event)" accept multiple />
        <!--<Button type="primary">上传</Button>-->
    </div>
</template>
<style>
</style>
<script>
import OSS from "ali-oss";
import http from "../../libs/http.js";
import util from "../../libs/util.js";
export default {
    data() {
        return {
            name: ""
        };
    },
    created() {},
    methods: {
        //点击上传
        changePic(event) {
            let _file = event.target.files[0];
            let _this = this;
            let _arr = _file.name.split(".");
            let storeAs =
                "file/minimady/" + util.guid() + "." + _arr[_arr.length - 1];
            http.post("/aliyun/sts").then(res => {
                if (res) {
                    let client = new OSS({
                        accessKeyId: res.AccessKeyId,
                        accessKeySecret: res.AccessKeySecret,
                        stsToken: res.SecurityToken,
                        endpoint: process.env.VUE_APP_OSS_ENDPOINT + "/file/minimady",
                        bucket: process.env.VUE_APP_OSS_BUCKET
                    });
                    //storeAs表示上传的object name , file表示上传的文件
                    client
                        .multipartUpload(storeAs, _file)
                        .then(function(result) {})
                        .catch(function(err) {});
                }
            });
        }
    }
};
</script>